import { useContext } from 'react'
import { AuthCtx } from '@/contexts/authCtx'

export function useAuth() {
  const ctx = useContext(AuthCtx)
  if (ctx === undefined) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return ctx
}
